module.exports = __webpack_public_path__ + "static/paris-005-2380c80a14c8dec7a3b96adb9f04b7cd.jpg";